import type { SVGProps } from "react";

export const Insightly = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    viewBox="0 0 256 256"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>Insightly</title>
    <circle cx="56" cy="70" fill="#F95616" r="19" />
    <g
      fill="none"
      stroke="#F95616"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="38"
    >
      <path d="M56 110 L56 168 Q56 190 78 188" />
      <path d="M120 188 L120 120 C120 102 134 93 150 93 C167 93 178 106 178 124 L178 168 Q178 190 200 188" />
    </g>
  </svg>
);

export default Insightly;
